// This file needs to import from react-router since it's the abstraction
/* eslint-disable no-restricted-imports */
import { useHistory } from 'react-router-dom';
export { useLocation } from 'react-router-dom';
export { useParams } from 'react-router-dom';

type NavigateOptionsType = {
  replace?: boolean;
  state?: Record<string, unknown>;
};

export function useNavigate() {
  const history = useHistory();

  return (path: string | number, options?: NavigateOptionsType) => {
    if (typeof path === 'number') {
      history.go(path);
      return;
    }

    if (options?.replace) {
      history.replace(path);
      return;
    }

    history.push(path, options?.state);
  };
}
